import { keyframes } from "styled-components";

const OpacityAnimation = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export { OpacityAnimation };
